module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('section', {
    staticClass: "hero is-fullheight is-bold is-dark"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container has-text-centered"
  }, [_c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-3-desktop is-4-mobile is-offset-3-desktop is-offset-2-mobile is-4-tablet is-offset-2-tablet"
  }, [_c('div', {
    staticClass: "notification is-success",
    attrs: {
      "id": "green-button"
    },
    on: {
      "click": function($event) {
        _vm.padClicked(0)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column is-3-desktop is-4-mobile is-4-tablet"
  }, [_c('div', {
    staticClass: "notification is-danger",
    attrs: {
      "id": "red-button"
    },
    on: {
      "click": function($event) {
        _vm.padClicked(1)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-3-desktop is-4-mobile is-offset-3-desktop is-offset-2-mobile is-4-tablet is-offset-2-tablet"
  }, [_c('div', {
    staticClass: "notification is-warning",
    attrs: {
      "id": "yellow-button"
    },
    on: {
      "click": function($event) {
        _vm.padClicked(2)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column is-3-desktop is-4-mobile is-4-tablet"
  }, [_c('div', {
    staticClass: "notification is-info",
    attrs: {
      "id": "blue-button"
    },
    on: {
      "click": function($event) {
        _vm.padClicked(3)
      }
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "button is-dark is-inverted is-outlined has-text-centered is-large",
    on: {
      "click": _vm.startGame
    }
  }, [_vm._v("Start")]), _vm._v(" "), _c('a', {
    staticClass: "button is-dark is-inverted is-outlined has-text-centered is-large",
    on: {
      "click": _vm.showHelp
    }
  }, [_vm._v("Help")]), _vm._v(" "), _c('a', {
    staticClass: "button is-dark is-inverted is-outlined has-text-centered is-large"
  }, [_vm._v("Score: " + _vm._s(_vm.score))]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "help"
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "modal-close",
    on: {
      "click": _vm.closeHelp
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "result"
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('article', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('p', [_vm._v("Wrong Sequence")]), _vm._v(" "), _c('p', [_vm._v("Score: " + _vm._s(_vm.score))])])])]), _vm._v(" "), _c('button', {
    staticClass: "modal-close",
    on: {
      "click": _vm.closeResult
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('article', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("\n                                Simon is a game that tests your memory skills. To play, press start and repeat the series.\n                            ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3e4a6004"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 6
// module chunks = 0